import { render, staticRenderFns } from "./ManageUserTraces.vue?vue&type=template&id=c65a7944&"
import script from "./ManageUserTraces.vue?vue&type=script&lang=js&"
export * from "./ManageUserTraces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports